/* Atlantic Boba — minimal global JS for cart/quantity/accordion behaviour */

document.documentElement.classList.remove('no-js');

(function () {
  // ---------------------------------------------------------------
  // Toast notifications (used for partner-account gating + future
  // success/error messages from cart actions).
  // ---------------------------------------------------------------
  var toastContainer = null;
  function ensureToastContainer() {
    if (toastContainer) return toastContainer;
    toastContainer = document.createElement('div');
    toastContainer.className = 'ab-toast-container';
    toastContainer.setAttribute('aria-live', 'polite');
    toastContainer.setAttribute('aria-atomic', 'true');
    document.body.appendChild(toastContainer);
    return toastContainer;
  }
  function showToast(message, variant) {
    variant = variant || 'info';
    var t = document.createElement('div');
    t.className = 'ab-toast ab-toast--' + variant;
    t.textContent = message;
    ensureToastContainer().appendChild(t);
    // Force reflow so the animation runs from initial state
    void t.offsetWidth;
    t.classList.add('is-visible');
    setTimeout(function () {
      t.classList.remove('is-visible');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 250);
    }, 4000);
  }
  // Expose so other inline scripts can use it
  window.atlanticBoba = window.atlanticBoba || {};
  window.atlanticBoba.toast = showToast;

  // ---------------------------------------------------------------
  // Partner-account gating helper. Returns true if the given SKU is
  // restricted to partner-tagged customers.
  // ---------------------------------------------------------------
  function isRestrictedSku(sku) {
    if (!sku) return false;
    var patterns = (window.atlanticBoba && window.atlanticBoba.restrictedSkuPatterns) || [];
    for (var i = 0; i < patterns.length; i++) {
      if (sku.indexOf(patterns[i]) !== -1) return true;
    }
    return false;
  }
  function isPartner() {
    return !!(window.atlanticBoba && window.atlanticBoba.isPartner);
  }

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-action]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.qty');
    if (!wrap) return;
    var input = wrap.querySelector('input[type="number"]');
    if (!input) return;
    var current = parseInt(input.value, 10) || 0;
    var min = parseInt(input.min, 10) || 1;
    if (btn.dataset.qtyAction === 'inc') input.value = current + 1;
    if (btn.dataset.qtyAction === 'dec') input.value = Math.max(min, current - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Variant pills update the form's variant id
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-variant-id]');
    if (!pill) return;
    var form = pill.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = pill.dataset.variantId;
    if (pill.dataset.variantSku) form.dataset.sku = pill.dataset.variantSku;
    var pills = form.querySelectorAll('[data-variant-id]');
    pills.forEach(function (p) { p.classList.remove('is-selected'); });
    pill.classList.add('is-selected');
    // Update every price display on the page, but skip the pills themselves
    // — they also carry data-variant-price as a value source and must not have
    // their label overwritten with the price.
    if (pill.dataset.variantPrice) {
      document.querySelectorAll('[data-variant-price]:not([data-variant-id])').forEach(function (el) {
        el.textContent = pill.dataset.variantPrice;
      });
    }
  });

  // Quick Order add forms — submit via fetch /cart/add.js
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-quick-add]');
    if (!form) return;
    e.preventDefault();

    // Partner-account gate: tub/bag SKUs are only allowed for customers
    // tagged "partner-account". Standard customers must order by the case.
    var sku = form.dataset.sku || '';
    if (isRestrictedSku(sku) && !isPartner()) {
      showToast(
        'Minimum wholesale order is one case. Contact us about partner pricing for individual units.',
        'error'
      );
      return;
    }

    var data = new FormData(form);
    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding...'; }
    fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        if (btn) { btn.textContent = 'Added ✓'; setTimeout(function(){ btn.textContent = btn.dataset.label; btn.disabled = false; }, 1200); }
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function (err) {
        if (btn) { btn.textContent = btn.dataset.label || 'Add'; btn.disabled = false; }
        var msg = (err && err.description) || (err && err.message) || 'Could not add to cart.';
        showToast(msg, 'error');
      });
  });

  // Tabs (used in product page reviews)
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-tab]');
    if (!tab) return;
    var group = tab.closest('[data-tabs]');
    if (!group) return;
    var name = tab.dataset.tab;
    group.querySelectorAll('[data-tab]').forEach(function (t) { t.classList.toggle('is-active', t === tab); });
    group.querySelectorAll('[data-tab-panel]').forEach(function (p) {
      p.hidden = p.dataset.tabPanel !== name;
    });
  });

  // Shop / Quick Order "Load More" — fetches the next page of product
  // cards via /collections/{handle}?page=N&view={cards|cards-quick} and
  // appends them to the existing grid. No URL navigation.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-shop-loadmore]');
    if (!btn) return;
    e.preventDefault();
    var section = btn.closest('section');
    if (!section) return;
    var grid = section.querySelector('[data-shop-grid]');
    if (!grid) return;
    var handle = grid.dataset.collectionHandle;
    var view = grid.dataset.view || 'cards';
    var nextPage = parseInt(btn.dataset.nextPage, 10) || 2;

    btn.disabled = true;
    btn.dataset.label = btn.textContent;
    btn.textContent = 'Loading…';

    fetch('/collections/' + handle + '?page=' + nextPage + '&view=' + view, {
      headers: { 'Accept': 'text/html' }
    })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('.product-card');
        if (cards.length === 0) {
          // No cards returned — assume we hit the end.
          btn.parentNode.removeChild(btn);
          return;
        }
        cards.forEach(function (card) { grid.appendChild(card); });
        var hasNext = doc.querySelector('[data-has-next]');
        if (hasNext) {
          btn.dataset.nextPage = String(nextPage + 1);
          btn.disabled = false;
          btn.textContent = btn.dataset.label || 'Load More';
        } else {
          btn.parentNode.removeChild(btn);
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = btn.dataset.label || 'Load More';
      });
  });

  // Carousel arrows (Popular Products / Related Products)
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var prevBtns = root.querySelectorAll('[data-carousel-prev]');
    var nextBtns = root.querySelectorAll('[data-carousel-next]');

    function step() {
      // Scroll by ~one card width: read first child's offsetWidth + gap.
      var first = track.firstElementChild;
      if (!first) return track.clientWidth * 0.8;
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return first.offsetWidth + gap;
    }

    function refresh() {
      var max = track.scrollWidth - track.clientWidth - 1; // -1 for sub-pixel
      var atStart = track.scrollLeft <= 0;
      var atEnd = track.scrollLeft >= max;
      var hasOverflow = track.scrollWidth > track.clientWidth + 1;
      prevBtns.forEach(function (b) { b.disabled = atStart || !hasOverflow; });
      nextBtns.forEach(function (b) { b.disabled = atEnd || !hasOverflow; });
    }

    prevBtns.forEach(function (b) {
      b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    });
    nextBtns.forEach(function (b) {
      b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });

    track.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);
    // Initial state (defer one frame so layout has settled)
    requestAnimationFrame(refresh);
  });
})();
